import { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { HelmetProvider } from "react-helmet-async"; // ✅ Додати імпорт

import App from "./App.tsx";
import "./styles/index.scss";
import { initI18n } from "./config/i18n.ts";

import { CartProvider } from "./context/CartContext.tsx";
import { CartModalProvider } from "./context/CartModalContext";

const Root = () => {
  const [i18nInstance, setI18nInstance] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initialize = async () => {
      try {
        const i18n = await initI18n();
        setI18nInstance(i18n);
      } catch (error) {
        console.error("Failed to initialize i18n:", error);
      } finally {
        setLoading(false);
      }
    };

    initialize();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontFamily: "sans-serif",
        }}
      >
        Loading application...
      </div>
    );
  }

  if (!i18nInstance) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          color: "red",
          fontFamily: "sans-serif",
        }}
      >
        Failed to initialize application
      </div>
    );
  }

  return (
    <HelmetProvider>
      {" "}
      {/* ✅ Додати тут */}
      <I18nextProvider i18n={i18nInstance}>
        <BrowserRouter>
          <CartProvider>
            <CartModalProvider>
              <App />
            </CartModalProvider>
          </CartProvider>
        </BrowserRouter>
      </I18nextProvider>
    </HelmetProvider>
  );
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Root />
  </StrictMode>
);
